import { render, staticRenderFns } from "./tax-class-options.vue?vue&type=template&id=4ce87961&scoped=true"
import script from "./tax-class-options.vue?vue&type=script&lang=js"
export * from "./tax-class-options.vue?vue&type=script&lang=js"
import style0 from "./tax-class-options.vue?vue&type=style&index=0&id=4ce87961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce87961",
  null
  
)

export default component.exports